var Endpoints;
(function (Endpoints) {
  Endpoints["TWO_FACTOR_CHALLENGE"] = "two-factor/v1/challenge";
  Endpoints["TWO_FACTOR_SMS_RESEND"] = "two-factor/v1/challenge/new-code";
  Endpoints["TWO_FACTOR_SMS_CALL"] = "two-factor/v1/challenge/call";
  Endpoints["TWO_FACTOR_AUTHENTICATE"] = "two-factor/v1/authenticate";
  Endpoints["MOBILE_AUTHENTICATOR_POLL_APPROVE"] = "two-factor/v1/authenticate/approved-request";
  Endpoints["MOBILE_AUTHENTICATOR_POLL"] = "two-factor/v1/requests/poll";
  Endpoints["TWO_FACTOR_STATUS"] = "two-factor/v1/status/hubless";
  Endpoints["COOKIE_ISSUER_VALID"] = "cookie-echo/v1/cookie-issuer-valid";
  Endpoints["PASSKEY_SETTINGS"] = "passkey-login/settings";
  Endpoints["PASSKEY_INITIATE"] = "passkey-login/authentication/initiate";
  Endpoints["PASSKEY_VALIDATE"] = "passkey-login/reauth/validate";
})(Endpoints || (Endpoints = {}));
export default Endpoints;